import React from 'react';
import {
  AdditionalInformationListSeparator,
  MealPlanOptionsByMealPlan,
} from '@/app/components/hotel-detail/rooms/RoomPanelMealPlanOptions';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { RoomMobileHeader, RoomMobileImageGallery, RoomMobileInfoSection } from './RoomPanelMobileParts';

type RoomPanelModalContentMobileProps = {
  hideMealPlanOptionsAdditionalInformation?: boolean;
  room: RoomType;
  onContinueClick?: (selectedMealPlan: MealPlanType) => void;
  onSelectMealPlan?: (selectedMealPlan: MealPlanType) => void;
  selectedMealPlan?: MealPlanType;
} & React.HTMLAttributes<HTMLElement>;

export function RoomPanelModalContentMobile(props: RoomPanelModalContentMobileProps) {
  const { localization } = usePageWrapperData();
  const {
    room,
    onContinueClick,
    onSelectMealPlan,
    selectedMealPlan,
    hideMealPlanOptionsAdditionalInformation,
    ...rest
  } = props;

  const roomsLeft = room.configurations?.[0]?.roomsLeft;
  const extendedRoomPanel = localization?.configValuesApp?.mobileShowAllRooms || false;

  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        padding: 16px 16px 24px 16px;
        gap: 16px;
      `}
      {...rest}
    >
      <RoomMobileImageGallery
        images={room.images}
        name={room.name}
        height={180}
        rounded={true}
        tabletTallHeight={360}
      />

      <RoomMobileHeader roomName={room.name} roomsIncludedInPrice={room.roomsIncludedInPrice} roomsLeft={roomsLeft} />

      <MealPlanOptionsByMealPlan
        context="room-panel-modal"
        room={room}
        variation="single-column"
        showBedSelection={true}
        showSelectedMealPlanPriceSection={extendedRoomPanel}
        selectedMealPlan={selectedMealPlan || room.configurations[0]}
        hideAdditionalInformation={hideMealPlanOptionsAdditionalInformation}
        onContinueClick={onContinueClick}
        onSelectMealPlan={onSelectMealPlan}
        css={`
          ${AdditionalInformationListSeparator} {
            display: none;
          }
        `}
      />

      <RoomMobileInfoSection room={room} selectedMealPlan={selectedMealPlan} />
    </div>
  );
}
